import { LucideIconData } from 'lucide-angular';

export const PoolCaC3: LucideIconData = [
  ['circle', { cx: '12', cy: '12', r: '10' }],
  ['rect', { x: '8', y: '9', width: '8', height: '8', rx: '1' }],
  ['path', { d: 'M8 7 V10' }],
  ['path', { d: 'M12 7 V8' }],
  ['path', { d: 'M16 7 V10' }],
];
